import { Link, useLocation } from 'react-router-dom';
import './Nav.css';
import logo from '../assets/logo/insane-vegan-logo-black.svg';
import tape from '../assets/cutouts/tape.png';

// Every link is wired to a real route (`to`) — `href` is kept as a fallback
// for any future placeholder/external link that doesn't have a route yet.
//
// There's no `active` flag here on purpose: the active item is derived from
// the current URL below, so a new page can never forget to set it.

const LINKS = [
  { label: 'Home', to: '/' },
  //{ label: 'Recipes', to: '/recipes' },
  //{ label: 'Events', to: '/events' },
  { label: 'Our App', to: '/our-app' },
  { label: 'Contact Us', to: '/contact', accent: true },
];

function Nav() {
  const { pathname } = useLocation();

  return (
    <nav className="Nav">
      <div className="Nav-paper" aria-hidden="true" />
      <div className="Nav-tornEdge" aria-hidden="true" />
      <Link className="Nav-logo" to="/">
        <img src={logo} alt="Insane Vegan" />
      </Link>
      <ul className="Nav-links">
        {LINKS.map(({ label, href, to, accent }) => {
          const isActive = to === pathname;

          return (
            <li key={label}>
              {isActive && <img className="Nav-activeTape" src={tape} alt="" aria-hidden="true" />}
              {to ? (
                <Link
                  to={to}
                  className={accent ? 'Nav-accentLink' : undefined}
                  aria-current={isActive ? 'page' : undefined}
                >
                  {label}
                </Link>
              ) : (
                <a href={href} className={accent ? 'Nav-accentLink' : undefined}>
                  {label}
                </a>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default Nav;
